import { Textarea } from "@/components/ui/textarea";

interface OutputPanelProps {
  output: string;
  isRunning: boolean;
}

export function OutputPanel({ output, isRunning }: OutputPanelProps) {
  return (
    <section
      aria-label="Output"
      aria-busy={isRunning}
      className="flex h-full min-h-0 min-w-0 flex-col gap-2 overflow-hidden p-4"
    >
      <label htmlFor="verification-output" className="text-xs font-medium">
        Output
      </label>
      <Textarea
        id="verification-output"
        value={output}
        readOnly
        spellCheck={false}
        className="field-sizing-fixed min-h-0 flex-1 resize-none overflow-auto border-zinc-700 bg-zinc-900 font-mono text-sm leading-6 text-zinc-100 scheme-dark"
      />
      <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
      >
        {output}
      </div>
    </section>
  );
}
